// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgOrderDeliveredIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 3c.24 0 .47.09.66.25l8 7c.32.27.43.71.28 1.1s-.52.65-.94.65h-1v7c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-7H4c-.42 0-.79-.26-.94-.65-.14-.39-.03-.83.28-1.1l8-7c.19-.17.42-.25.66-.25m3.707 9.293a1 1 0 0 0-1.414 0L11 15.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414"
      clipRule="evenodd"
    />
  </g>
);
export default SvgOrderDeliveredIcon;
SvgOrderDeliveredIcon.displayName = 'SvgOrderDeliveredIcon';
